import React from 'react'

import PropTypes from 'prop-types'

import './footer-column.css'

const FooterColumn = (props) => {
  return (
    <div className="footer-column-thq-footer-column-elm footer-contact-col footer-column">
      <h2 className="section-subtitle footer-title">Contact Us</h2>
      <div className="footer-contact-info">
        <a
          href={props.smsLink?.['url']}
          target={props.smsLink?.['newTab'] ? '_blank' : undefined}
          rel={props.smsLink?.['newTab'] ? 'noreferrer noopener' : undefined}
        >
          <div className="footer-column-thq-footer-contact-item-elm1 footer-contact-item">
            <div className="footer-icon-wrapper">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="footer-contact-text">
              <span className="footer-contact-label">Call Or TExt Now</span>
              <div className="footer-contact-link">
                <span>(214) 355-0875</span>
              </div>
            </div>
          </div>
        </a>
        <a href="mailto:ksprocess@verizon.net?subject=Service Request">
          <div className="footer-column-thq-footer-contact-item-elm2 footer-contact-item">
            <div className="footer-icon-wrapper">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                  <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                </g>
              </svg>
            </div>
            <div className="footer-contact-text">
              <span className="footer-contact-label">Email Us</span>
              <div className="footer-contact-link">
                <span>ksprocess@verizon.net</span>
              </div>
            </div>
          </div>
        </a>
        <div className="footer-contact-item">
          <div className="footer-icon-wrapper">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle r="3" cx="12" cy="10"></circle>
              </g>
            </svg>
          </div>
          <div className="footer-contact-text">
            <span className="footer-contact-label">Service Area</span>
            <span className="footer-contact-value">DFW / Nationwide</span>
          </div>
        </div>
      </div>
    </div>
  )
}

FooterColumn.defaultProps = {
  smsLink: {
    url: 'sms:+12143550875;?&body=Hi%2C%20I%27m%20interested%20in%20hiring%20a%20process%20server.%20Could%20you%20provide%20more%20information%3F',
    newTab: true,
  },
}

FooterColumn.propTypes = {
  smsLink: PropTypes.object,
}

export default FooterColumn
